export const AddAttendanceContent = {
  title: 'Add Attendees',
  searchPlaceholder: 'Search by name...',
  emptyPrompt:
    'Search by name to find attendees. Selected people will appear here.',
  noMatches: 'No people match your search.',
  suggestedLabel: 'Suggested',
  attendeesLabel: 'Attendees',
  memberWithoutProfile: 'Member without profile',
  buttons: {
    cancel: 'Cancel',
    save: 'Save',
  },
} as const;


